// Also known as GA Content Group
import { getSearchParameters } from '../state';
import { getSeoHasSalpBlockContent } from '../../Shared/Seo';
import isZocdocBrand from '../../utils/isZocdocBrand';

export const getZlogPageType = state => {
    const params = getSearchParameters(state);
    const { directoryId, threatLevel } = params;
    if (!isZocdocBrand(directoryId)) {
        return 'SearchBrandedIndex';
    }
    switch (threatLevel) {
        case ThreatLevel.SingleSpec:
            return 'SearchStSpecialy';
        case ThreatLevel.SingleProc:
            return 'SearchStProcedure';
        case ThreatLevel.DoubleIns:
            return 'SearchDtInsurance';
        case ThreatLevel.DoubleLoc:
            return 'SearchDtLocation';
        case ThreatLevel.DoubleLang:
            return 'SearchDtLanguage';
        case ThreatLevel.Triple:
            return 'SearchTt';
        case ThreatLevel.None:
            return 'SearchTypeIn';
        default:
            return 'SearchTypeIn';
    }
};

export const getZlogRollupBucket = state => {
    const params = getSearchParameters(state);
    const { directoryId, threatLevel } = params;
    if (!isZocdocBrand(directoryId)) {
        return 'SearchBrandedIndex';
    } else if (!threatLevel || threatLevel === 'None') {
        return 'SearchTypeIn';
    } else {
        return 'SearchThreat';
    }
};

// ZlogContentType has a value when the page is a SALP page with block content
export const getZlogContentType = state => {
    const hasSalpBlockContent = getSeoHasSalpBlockContent(state);
    if (!hasSalpBlockContent) {
        return null;
    }

    const params = getSearchParameters(state);
    switch (params.threatLevel) {
        case ThreatLevel.SingleSpec:
            return ZlogContentType.SALPSpecialty;
        case ThreatLevel.SingleProc:
            return ZlogContentType.SALPProcedure;
        case ThreatLevel.DoubleIns:
            return ZlogContentType.SALPDtInsurance;
        case ThreatLevel.DoubleLoc:
            return ZlogContentType.SALPDtLocation;
        case ThreatLevel.DoubleLang:
            return ZlogContentType.SALPDtLanguage;
        case ThreatLevel.Triple:
            return ZlogContentType.SALPTt;
        default:
            return null;
    }
};

export const ZlogContentType = {
    SALPSpecialty: 'SALPSpecialty',
    SALPProcedure: 'SALPProcedure',
    SALPDtInsurance: 'SALPDtInsurance',
    SALPDtLocation: 'SALPDtLocation',
    SALPDtLanguage: 'SALPDtLanguage',
    SALPTt: 'SALPTt',
};

export const ThreatLevel = {
    SingleSpec: 'SingleSpec',
    SingleProc: 'SingleProc',
    DoubleIns: 'DoubleIns',
    DoubleLoc: 'DoubleLoc',
    DoubleLang: 'DoubleLang',
    Triple: 'Triple',
    None: 'None',
};
